import { downloadFile, resolveExportResponse } from "@lib/helperFile"
import type { IExportQueuedResult } from "@lib/helperFile"
import http from "@services/httpService"
import dayjs from "dayjs"

class ReportService {
  public async getReport(params: any): Promise<any> {
    const res = await http.get("api/services/app/BookingReport/GetReport", {
      params,
    })
    const { result } = res.data

    return result
  }

  /**
   * Lấy dữ liệu báo cáo tổng thu nhập hàng ngày
   * @param params 
   * - ProjectIds
   * - FromDate
   * - ToDate
   * - ContractIds
   * - CustomerId
   * - CartIds
   * @returns 
   */
  public async getDailyCollection(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportDailyCollection", {
      params,
    })
    const { result } = res.data

    return result
  }

  /**
   * Lấy dữ liệu báo cáo hạn thanh toán
   * @param params 
   * - ProjectIds
   * - FromDate
   * - ToDate
   * - ContractIds
   * - CustomerId
   * - CartIds
   * @returns 
   */
  public async getDueDate(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportDueDate", {
      params,
    })
    const { result } = res.data

    return result
  }

  /**
   * 
   * @param params 
   * ProjectId (required)
   * FromDate
   * ToDate
   * ContractIds
   * CustomerId
   * CartIds
   * @returns 
  */
  public async getRevenueStatement(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportRevenueStatement", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async GetReportSaleStatus(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportSaleStatus", {
      params
    })
    const { result } = res.data
    return result
  }

  /**
   * 
   * @param params 
   * ProjectId (required)
   * FromDate
   * ToDate
   * ContractIds
   * CustomerId
   * CartIds
   * @returns 
  */
  public async getQuickCollection(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportQuickCollection", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async GetReportDebitNote(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportDebitNote", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async GetReportArAging(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportArAging", {
      params,
    })
    const { result } = res.data
    return result
  }

  public async GetReportAgingSum(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportAgingSumByUnit", {
      params,
    })
    const { result } = res.data
    return result
  }

  /**
   * Lấy dữ liệu báo cáo Aging Group by Unit
   * @param params
   * - ProjectIds, CartIds
   * - FromDate, ToDate, CalculateDate
   * - ContractIds, ContractType
   * - CustomerId, UnitIds, ProjectId
   * - IsForExport, SkipCount, MaxResultCount
   */
  public async GetReportAgingGroup(params: any): Promise<any> {
    const res = await http.get("api/services/app/Report/GetReportAgingGroupByUnit", {
      params,
    })
    const { result } = res.data
    return result
  }


  public async exportDailyCollection(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportReportDailyCollection", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-DAILY-COLLECTION-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportDueDate(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportReportDueDate", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-DUE-DATE-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportQuickCollection(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportReportQuickCollection", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-QUICK-COLLECTION-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  

  public async exportSaleStatus(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportReportSaleStatus", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-SALES-STATUS-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  /**
   * Export Core: BE trả blob khi dữ liệu nhỏ, `202` + JSON khi đẩy sang job nền.
   * Trả `null` = đã tải tệp; trả object = job đã vào hàng đợi, scene phải báo cho user.
   */
  public async exportDebitNote(
    params: any
  ): Promise<IExportQueuedResult | null> {
    const res = await http.get("api/Export/ExportReportDebitNote", {
      params,
      responseType: "blob",
    })
    return resolveExportResponse(
      res,
      `EXPORT-DEBIT-NOTE-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`
    )
  }

  public async exportArAging(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportReportArAging", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-AR-AGING-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportAgingSum(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportReportAgingSumByUnit", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-AGING-SUM-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportAgingGroup(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportReportAgingGroupByUnit", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-AGING-GROUP-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
  /** Xem `exportDebitNote` — cùng hợp đồng 200-blob / 202-queued của Export Core. */
  public async exportRevenueStatement(
    params: any
  ): Promise<IExportQueuedResult | null> {
    const res = await http.get("api/Export/ExportReportRevenueStatement", {
      params,
      responseType: "blob",
    })
    return resolveExportResponse(
      res,
      `EXPORT-REVENUE-STATEMENT-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`
    )
  }


}

export default new ReportService()
